import { Modal } from "bootstrap";
import React, { createRef, useEffect, useState } from "react";
import { useInvitations } from "../context/invitations";
import { deleteInvitation, updateInvitation } from "../services/firebase/firebase";

const newInvitation = {
    email: '',
    type: 'Socio de Tránsito'
}

export const SendInvitationModal = React.forwardRef((props, ref) => {

    const [loading, setLoading] = useState(false)
    const [form, setForm] = useState(newInvitation)
    // const [invitaciones, setInvitationes] = useState([])

    const { hideModal } = props

    // const addInvitation = (e) => {
    //     e.preventDefault()
    //     if (!form.email) return alert('Es necesario introducir un email')
    //     setInvitationes([...invitaciones, form])
    //     setForm(newInvitation)
    // }

    // const modifyInvitation = (email, type) => {
    //     const newInvitaciones = invitaciones.map(inv => {
    //         if (inv.email === email) return { ...inv, type }
    //         return
    //     })
    //     setInvitationes(newInvitaciones)
    // }

    // const deleteInvitation = (email) => {
    //     const newInvitaciones = invitaciones.filter(inv => inv.email != email)
    //     setInvitationes(newInvitaciones)
    // }

    return (
        <div className="modal fade" ref={ref} tabIndex="-1">
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Enviar invitaciones</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body text-start">
                        <div className='container'>
                            <div className="d-flex justify-content-between align-items-center my-3">
                                <input className="form-control mx-1" placeholder="Email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
                                <select className="form-select mx-2" value={form.type} onChange={e => setForm({ ...form, type: e.target.value })}>
                                    <option value="Socio de Transito">Socio de Tránsito</option>
                                    <option value="Socio Permanente">Socio Permanente</option>
                                    <option value='Socio de Honor'>Socio de Honor</option>
                                </select>
                                {/* <button className="btn  btn-warning mx-1 text-nowrap" onClick={addInvitation}>
                                    <i className="fa fa-plus me-2" />
                                    Añadir
                                </button> */}
                            </div>
                            {/* <div className="d-flex align-items-center justify-content-between my-3">
                                <label>Lista de invitaciones</label>
                                <button className="btn btn-light">Importar lista desde archivo</button>
                            </div> */}
                            {/* <ul className="list-group">
                                {invitaciones.length < 1 ?
                                    <span>No has invitado a nadie</span>
                                    :
                                    invitaciones.map((inv, i) => (
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                            <span>{inv.email}</span>
                                            <select className="form-select" style={{ width: '27%' }} value={inv.type} onChange={e => modifyInvitation(inv.email, e.target.value)}>
                                                <option value="Socio de Transito">Socio de Tránsito</option>
                                                <option value="Socio Permanente">Socio Permanente</option>
                                                <option value='Socio de Honor'>Socio de Honor</option>
                                            </select>
                                            <i className="fa fa-times" style={{ cursor: 'pointer' }} onClick={() => deleteInvitation(inv.email)} />
                                        </li>
                                    ))
                                }
                            </ul> */}
                        </div>
                    </div>
                    <div className="modal-footer justify-content-end">
                        <button type="button" className="btn btn-dark" >{loading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : 'Enviar'}</button>
                    </div>
                </div>
            </div>
        </div>
    )
})

export const InvitationModal = React.forwardRef((props, ref) => {

    const [loading, setLoading] = useState(false)
    const { data, hideModal } = props

    return (
        <div className="modal fade" ref={ref} tabIndex="-1">
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Información</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body text-start">
                        <div className='container'>
                            <div className="form-group">
                                <label>Email</label>
                                <input className="form-control mx-1" placeholder="Email" value={data.email} disabled />
                            </div>
                            <div className="form-group">
                                <label>Tipo de socio</label>
                                <select className="form-select mx-1" value={data.type} disabled>
                                    <option value="Socio de Transito">Socio de Tránsito</option>
                                    <option value="Socio Permanente">Socio Permanente</option>
                                    <option value='Socio de Honor'>Socio de Honor</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer justify-content-end">
                        <button type="button" className="btn btn-dark">{loading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : 'Enviar'}</button>
                    </div>
                </div>
            </div>
        </div>
    )
})


const Invitation = ({ data: invitation }) => {
    const {deleteInvitation } = useInvitations()
    const modalRef = createRef()

    const showModal = () => {
        const modalEle = modalRef.current
        const bsModal = new Modal(modalEle, {
            backdrop: 'static',
            keyboard: false
        })
        bsModal.show()
    }

    const hideModal = () => {
        const modalEle = modalRef.current
        const bsModal = Modal.getInstance(modalEle)
        bsModal.hide()
        // refresh()
    }

    const getPartnerColor = () => {
        if (invitation.type === 'Socio Fundador') return '#c8e5eb'
        if (invitation.type === 'Socio de Honor') return '#F0E68C'
        if (invitation.type === 'Socio Permanente') return '#BEBEBE'
        return ''
    }

    const doDelete = (e) => {
        e.preventDefault()
        if (window.confirm('¿Está seguro de que desea eliminar esta promoción?')) deleteInvitation(invitation.id)
        return
    }

    return (
        <tr>
            <td>{invitation?.name}</td>
            <td>{invitation?.email}</td>
            <td>
                <div className="card" style={{ backgroundColor: getPartnerColor(invitation.type) }}>
                    {invitation.type}
                </div>
            </td>
            {/* <td>{invitation?.creationDate}</td>
            <td>{invitation?.nsent}</td> */}
            <td>
                <div>
                    <button className="btn btn-sm btn-outline-success me-1"
                        onClick={showModal}>
                        <i className="fa fa-pencil" style={{ fontSize: '18px' }} />
                    </button>
                    <button className="btn btn-sm btn-outline-danger"
                        onClick={doDelete}>
                        <i className="fa fa-trash" style={{ fontSize: '18px' }} />
                    </button>
                    <InvitationModal data={invitation} hideModal={hideModal} ref={modalRef} />
                </div>
            </td>
        </tr>
    )
}

export default Invitation;